import React, { useCallback, useEffect, useState } from "react";
import { Row, Form, Tab, Tabs, Col, Container, Collapse, Alert, Button } from "react-bootstrap";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import isEmpty from "../../../../utils/is-Empty";
import StatCard from "../../../common/StatCard";
import "./index.css";
import Address from "../../common/Address";
import BankingAndTaxation from "../../common/BankingAndTaxation";
import { appConstants, regex, stringConstants } from "../../../../helpers/app-constants";
import FactoryInfo from "../FactoryInfo";
import { patchUsers } from "../../../../actions/auth.actions";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import {
  getApi,
  patchEnquiry,
  patchOrder,
  postGetGSTPrice,
} from "../../../../actions/structure.action";
import FilterObjectsByKeyValue from "../../../../utils/FilterObjectsByKeyValue";
import CustomTable from "../../common/CustomTable";
import { tableStructures } from "../../../../helpers/table-structures";
import { CloseIcon, ViewIcon } from "../../../../assets/svg/svg-icons";
import DashbordOrder from "../../common/DashbordOrder/indes";
import CustomModalWrap from "../../../common/CustomModalWrap";
import RepeatOrders from "../../../../assets/images/icons/RepeatOrders.png";
import TotalSale from "../../../../assets/images/icons/Sales.png";
import NewOrders from "../../../../assets/images/icons/NewOrders.png";
import Customers from "../../../../assets/images/icons/Customers.png";
import TimestampConverter from "../../../../utils/TimestampConverter";
import { getLogisticPartners, getUserSubscription } from "../../../../actions/user.actions";
import setAuthToken from "../../../../utils/setAuthToken";
import { toast } from "react-toastify";
import PageSpinner from "../../../common/PageSpinner";
import EnquiryDetails from "../../../Enquiry/EnquiryDetails";
import { Link } from "react-router-dom";
import { useDialog } from "../../../../helpers/useDialog";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import { debounce } from "lodash";
import LogisticPartner from "../../common/LogisticPartner";

const Dashbord = ({ notificationOrderId, notificationEnquiryId }) => {
  const dispatch = useDispatch();
  const { alert, confirm, DialogModal } = useDialog();
  const [newOrder, setNewOrder] = useState([]);
  const [acceptedOrder, setAcceptedOrder] = useState([]);
  const [activeOnboardingTab, setActiveOnboardingTab] = useState("address");
  const [showOrderModal, setOrderModal] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState("");
  const [isOpen, setIsOpen] = useState(true); // Collapsed/expanded state for enquiries
  const [isOrderOpen, setIsOrderOpen] = useState(true); // Collapsed/expanded state for orders
  const [mySubscription, setMySubscription] = useState(null);
  const [file, setFile] = useState(null);
  const [deliveryFormObj, setDeliveryFormObj] = useState({});
  const [billingAddress, setBillingAddress] = useState(null);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [warehouseAddress, setWarehouseAddress] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [topMessage, setTopMessage] = useState([]);
  const [currentEnquiryPkId, setCurrentEnquiryPkId] = useState("");
  const [showEnquiryModel, setEnquiryModal] = useState(false);
  const [pendingEnquiries, setPendingEnquiries] = useState([]);
  const [lpList, setLpList] = useState([]);
  const [steps, setSteps] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

  const orderViewToggle = () => setOrderModal(!showOrderModal);
  const enquiryViewToggle = () => setEnquiryModal(!showEnquiryModel);
  const EnquiryDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Enquiry"}</h4>
            <p
              onClick={() => {
                enquiryViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showEnquiryModel}
        showModal={enquiryViewToggle}
        closeModal={enquiryViewToggle}
      >
        <EnquiryDetails
          id={currentEnquiryPkId}
          currentEnquiry={pendingEnquiries.find((enq) => enq.enquiry_pk_id === currentEnquiryPkId)}
        />
      </CustomModalWrap>
    );
  };

  const {
    auth,
    addresses,
    bankInfo,
    factoryInfo,
    requestCall,
    bhareeAdminBasicTable,
    orders,
    enquiry,
    userSubscriptionInfo,
    companyInfo,
    checkEmailVerified,
  } = useSelector((state) => {
    return state;
  });

  const TABS = {
    ADDRESS: "address",
    BANKING: "banking info",
    FACTORY: "factory info",
    LOGISTICS: "logistics",
    FINAL: "final",
  };
  const TAB_ORDER = [TABS.ADDRESS, TABS.BANKING, TABS.FACTORY, TABS.LOGISTICS, TABS.FINAL];
  const visibleTabs = TAB_ORDER.slice(0, TAB_ORDER.indexOf(activeOnboardingTab) + 1);
  const STEPS = [
    { key: TABS.ADDRESS, label: "Address" },
    { key: TABS.BANKING, label: "Banking" },
    { key: TABS.FACTORY, label: "Factory" },
    { key: TABS.LOGISTICS, label: "Logistics" },
    { key: TABS.FINAL, label: "Final" },
  ];

  const loadLPList = (auth, dispatch) => {
    getLogisticPartners(auth?.user?.id, auth?.user?.role?.role_name, dispatch).then((res) => {
      setLpList(res.data);
    });
  };

  useEffect(() => {
    if (auth?.user?.id) {
      loadLPList(auth, dispatch);
    }
  }, [auth, dispatch]);

  const checkDate = (inputDate) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize time part

    const givenDate = new Date(inputDate);
    givenDate.setHours(0, 0, 0, 0);

    // Condition 1: given date is greater than today AND within 30 days
    const diffInTime = givenDate.getTime() - today.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);
    const isWithin30Days = diffInDays > 0 && diffInDays <= 30;

    // Condition 2: given date has already crossed today
    const isPast = givenDate < today;

    return { isWithin30Days, isPast };
  };

  useEffect(() => {
    if (!isEmpty(notificationOrderId)) {
      setCurrentOrderId(notificationOrderId);
      orderViewToggle();
    }
  }, [notificationOrderId]);

  useEffect(() => {
    if (!isEmpty(notificationEnquiryId) && !isEmpty(pendingEnquiries)) {
      if (pendingEnquiries.length > 0) {
        const notificationEnquiry = pendingEnquiries.find(
          (el) => el.enquiry_id === notificationEnquiryId,
        );
        if (!isEmpty(notificationEnquiry)) {
          setCurrentEnquiryPkId(notificationEnquiry.enquiry_pk_id);
          enquiryViewToggle();
        }
      }
    }
  }, [notificationEnquiryId, pendingEnquiries]);

  useEffect(() => {
    getApi("getBhreeAdminBasicTables", dispatch);
    getApi("getOrders", dispatch);
    getApi("getEnquiry", dispatch);
    getApi("checkEmailVerified", dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (auth && auth.user && auth.user.id) {
      // Fetch user subscription details if needed
      setPageLoading(true);
      getUserSubscription(auth.user.id, dispatch).finally(() => {
        setPageLoading(false);
      });

      if (auth?.user?.onboarding) {
        getApi("getCompanyInfo", dispatch);
        if (auth?.user?.roles_type?.role_type_name === "MANUFACTURER") {
          getApi("getFactoryInfo", dispatch);
        }
      }
    }
  }, [auth, dispatch]);

  useEffect(() => {
    if (userSubscriptionInfo && userSubscriptionInfo.data) {
      setMySubscription(userSubscriptionInfo.data);
    }
  }, [userSubscriptionInfo]);

  useEffect(() => {
    if (!auth.user.onboarding && !isEmpty(bhareeAdminBasicTable?.data)) {
      onSelectValue(
        FilterObjectsByKeyValue(bhareeAdminBasicTable?.data?.deliveryTypes, "name", "Standard"),
        "delivery_types",
      );
      onSelectValue(
        FilterObjectsByKeyValue(bhareeAdminBasicTable?.data?.paymentTypes, "name", "Pay Now"),
        "payment_types",
      );
    }
  }, [bhareeAdminBasicTable, auth]);

  useEffect(() => {
    // Find the billing address
    // If role type is manufacturer or distributor, find the delivery or warehouse address
    // If role type is manufacturer, find factory address
    setErrorMessage(null);
    let mBillingAddress = null;
    let mDeliveryAddress = null;
    let mWareHouseAddress = null;
    if (addresses?.data?.length > 0) {
      mBillingAddress = addresses.data.find(
        (el) => el.address_type_id.type_name.toLowerCase() === "billing",
      );
      if (!isEmpty(mBillingAddress)) {
        setBillingAddress(mBillingAddress);
      }

      mDeliveryAddress = addresses.data.find(
        (el) => el.address_type_id.type_name.toLowerCase() === "delivery",
      );
      if (!isEmpty(mDeliveryAddress)) {
        setDeliveryAddress(mDeliveryAddress);
      }

      mWareHouseAddress = addresses.data.find(
        (el) => el.address_type_id.type_name.toLowerCase() === "warehouse",
      );
      if (!isEmpty(mWareHouseAddress)) {
        setWarehouseAddress(mWareHouseAddress);
      }
    }

    if (addresses?.data?.length < 1) {
      setActiveOnboardingTab(TABS.ADDRESS);
    } else if (isEmpty(mBillingAddress)) {
      setActiveOnboardingTab(TABS.ADDRESS);
    } else if (isEmpty(mDeliveryAddress) && isEmpty(mWareHouseAddress)) {
      setActiveOnboardingTab(TABS.ADDRESS);
    } else if (addresses?.data?.length > 0 && isEmpty(bankInfo?.data)) {
      setActiveOnboardingTab(TABS.BANKING);
    } else if (
      addresses?.data?.length > 0 &&
      !isEmpty(bankInfo?.data) &&
      auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER &&
      isEmpty(factoryInfo?.data)
    ) {
      setActiveOnboardingTab(TABS.FACTORY);
    } else if (
      addresses?.data?.length > 0 &&
      !isEmpty(bankInfo?.data) &&
      auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER &&
      !isEmpty(factoryInfo?.data)
    ) {
      if (mySubscription?.sellerInfo?.app_features === "leads") {
        setActiveOnboardingTab(TABS.FINAL);
      } else {
        if (!isEmpty(lpList) && lpList?.length > 0) {
          setActiveOnboardingTab(TABS.FINAL);
        } else {
          setActiveOnboardingTab(TABS.LOGISTICS);
        }
      }
    } else if (
      addresses?.data?.length > 0 &&
      !isEmpty(bankInfo?.data) &&
      auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_DISTRIBUTOR
    ) {
      if (mySubscription?.sellerInfo?.app_features === "leads") {
        setActiveOnboardingTab(TABS.FINAL);
      } else {
        if (!isEmpty(lpList) && lpList?.length > 0) {
          setActiveOnboardingTab(TABS.FINAL);
        } else {
          setActiveOnboardingTab(TABS.LOGISTICS);
        }
      }
    }
  }, [addresses, bankInfo, factoryInfo, auth, mySubscription, lpList]);

  useEffect(() => {
    setTopMessage([]);
    let mMessages = [];
    if (auth?.user?.app_features === "leads" && !mySubscription?.is_subscription_active) {
      if (mySubscription?.sellerInfo?.is_trial) {
        mMessages.push(
          <>
            You are currently in trial mode. Your trial period will end on{" "}
            {TimestampConverter(auth?.user?.trial_end_date, true)}. Please {clickToSubscribe()} to
            continue using the services.
          </>,
        );
      } else {
        mMessages.push(
          <>
            Your trial has ended on {TimestampConverter(auth?.user?.trial_end_date, true)}. Please{" "}
            {clickToSubscribe()} to continue using the services.
          </>,
        );
      }
    }

    if (isEmpty(companyInfo?.data?.business_info?.authorized_signature)) {
      mMessages.push(
        "Please upload your authorized signature from Business Info > Company Info tab.",
      );
    }

    if (!isEmpty(factoryInfo)) {
      // BIS CML Renewal Date check
      if (!isEmpty(factoryInfo?.data?.bis_cml_renewal_date)) {
        const { isWithin30Days, isPast } = checkDate(factoryInfo?.data?.bis_cml_renewal_date);
        if (isWithin30Days) {
          mMessages.push(
            <>
              Your BIS CML Renewal is within 30 days and will expire on{" "}
              {TimestampConverter(factoryInfo?.data?.bis_cml_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest.
            </>,
          );
        } else if (isPast) {
          mMessages.push(
            <>
              Your BIS CML Renewal has expired on{" "}
              {TimestampConverter(factoryInfo?.data?.bis_cml_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest and upload the latest renewed document and
              update renewal date.`
            </>,
          );
        }
      }

      // EPR Renewal Date check
      if (!isEmpty(factoryInfo?.data?.epr_renewal_date)) {
        const { isWithin30Days, isPast } = checkDate(factoryInfo?.data?.epr_renewal_date);
        if (isWithin30Days) {
          mMessages.push(
            <>
              Your EPR Renewal is within 30 days and will expire on{" "}
              {TimestampConverter(factoryInfo?.data?.epr_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest.
            </>,
          );
        } else if (isPast) {
          mMessages.push(
            <>
              Your EPR Renewal has expired on{" "}
              {TimestampConverter(factoryInfo?.data?.epr_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest and upload the latest renewed document and
              update renewal date.
            </>,
          );
        }
      }

      // FSSAI Renewal Date check
      if (!isEmpty(factoryInfo?.data?.fssai_renewal_date)) {
        const { isWithin30Days, isPast } = checkDate(factoryInfo?.data?.fssai_renewal_date);
        if (isWithin30Days) {
          mMessages.push(
            <>
              Your FSSAI Renewal is within 30 days and will expire on{" "}
              {TimestampConverter(factoryInfo?.data?.fssai_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest.
            </>,
          );
        } else if (isPast) {
          mMessages.push(
            <>
              Your FSSAI Renewal has expired on{" "}
              {TimestampConverter(factoryInfo?.data?.fssai_renewal_date, true)}. Please{" "}
              {clickHereToRenew()} it at the earliest and upload the latest renewed document and
              update renewal date.
            </>,
          );
        }
      }
    }

    if (!isEmpty(checkEmailVerified?.data) && checkEmailVerified?.data?.email_verify_status === 0) {
      mMessages.push(
        <>Your email is not verified. Please {clickHereToVerify()} to verify your email address.</>,
      );
    }

    setTopMessage(mMessages);
  }, [auth, mySubscription, companyInfo, factoryInfo, checkEmailVerified]);

  const [statisticsData, setStatisticsData] = useState({});
  const [enquiryStatsData, setEnquiryStatsData] = useState({});
  const getOrderStatistics = async (sellerid) => {
    try {
      const res = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/orders/getOrderStatistics/${sellerid}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        },
      );
      if (res && res?.data?.success) {
        setStatisticsData(res.data.data);
      } else {
        setStatisticsData({});
      }
    } catch (err) {
      console.error("Error while getOrderStatistics:", err);
    }
  };
  const getEnquiryStatistics = async (sellerid) => {
    try {
      const res = await axios.get(
        `${BHAREE_BASE_URL_LOCAL}/enquiry/getEnquiryStatistics/${sellerid}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        },
      );
      if (res && res?.data?.success) {
        setEnquiryStatsData(res.data.data);
      } else {
        setEnquiryStatsData({});
      }
    } catch (err) {
      console.error("Error while getEnquiryStatistics:", err);
    }
  };

  useEffect(() => {
    if (
      auth &&
      auth.user &&
      auth.user.id &&
      auth.user?.role?.role_name === stringConstants.ROLL_SELLER
    ) {
      getOrderStatistics(auth?.user?.id);
      getEnquiryStatistics(auth?.user?.id);
    }
  }, [auth]);

  const clickToSubscribe = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          dispatch({
            type: stringConstants.SET_CURRENT_VIEW,
            payload: stringConstants.MY_SUBSCRIPTIONS,
          });
        }}
      >
        subscribe
      </Link>
    );
  };

  const clickHereToRenew = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          dispatch({
            type: stringConstants.SET_CURRENT_VIEW,
            payload: stringConstants.FACTORY_INFO,
          });
        }}
      >
        renew
      </Link>
    );
  };

  // Create a link to put it inside the top message for email verification
  const clickHereToVerify = () => {
    return (
      <Link
        variant="link"
        className="m-0 p-0"
        onClick={() => {
          setPageLoading(true);
          getApi("sendEmailVerificationLink", dispatch)
            .then((res) => {
              if (res?.rawData?.success) {
                toast.success("Verification link has been sent to your email address.");
              } else {
                toast.error("Failed to send verification link. Please try again.");
              }
            })
            .catch((err) => {
              toast.error("Failed to send verification link. Please try again.");
            })
            .finally(() => {
              setPageLoading(false);
            });
        }}
      >
        click here
      </Link>
    );
  };

  const onSelectValue = (value, selectorType) => {
    let updatedObj = {};
    updatedObj[selectorType] = value;
    setDeliveryFormObj((previousVlaues) => ({
      ...previousVlaues,
      ...updatedObj,
    }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) {
      setErrorMessage("❌ File size must be ≤ 2MB");
      return;
    }
    setFile(selectedFile);
    setErrorMessage("");
  };

  const completeOnboarding = (e) => {
    e.preventDefault();

    setErrorMessage(null);

    let errors = [];
    if (isEmpty(billingAddress)) {
      errors.push("Please add billing address.");
    }
    if (isEmpty(deliveryAddress) && isEmpty(warehouseAddress)) {
      errors.push("Please add delivery / warehouse address.");
    }
    if (!file) {
      errors.push("Please upload authorized signature file.");
    }
    if (errors.length > 0) {
      setErrorMessage(errors.join("<br/>"));
    } else {
      const dataUploadObj = {
        ...deliveryFormObj,
        signature: file,
      };

      console.log("completeOnboarding: dataUploadObj: ", dataUploadObj);

      let mPatchObj = { ...dataUploadObj, onboarding: true };
      if (dataUploadObj?.deliveryChargeFinal) {
        mPatchObj.deliveryCharge = dataUploadObj.deliveryChargeFinal;
      }
      if (dataUploadObj?.handlingChargesFinal) {
        mPatchObj.handling_charges = dataUploadObj.handlingChargesFinal;
      }

      console.log("---- Checking ----", mPatchObj);

      if (
        !isEmpty(dataUploadObj) &&
        Object.prototype.hasOwnProperty.call(dataUploadObj, "delivery_types") &&
        !isEmpty(dataUploadObj.delivery_types) &&
        Object.prototype.hasOwnProperty.call(dataUploadObj, "deliveryCharge") &&
        !isEmpty(dataUploadObj.deliveryCharge) &&
        Object.prototype.hasOwnProperty.call(dataUploadObj, "handling_charges") &&
        !isEmpty(dataUploadObj.handling_charges) &&
        dataUploadObj.signature
      ) {
        patchUsers(auth?.user?.id, mPatchObj, dispatch).then(async (res) => {
          await alert("Onboarding is complete. Please re-login again.");

          // Log out
          localStorage.removeItem("jwtToken");
          setAuthToken(false);
          dispatch({
            type: appConstants.LOGIN_SUCCESS,
            user: {},
          });
          window.location.href = "/";
        });
      }
    }
  };

  const acceptOrderStatus = (data) => {
    let sendObj = {};
    sendObj["id"] = data.id;
    sendObj["status"] = "accepted";
    patchOrder(sendObj, dispatch);
  };

  const acceptEnquiryStatus = (data) => {
    let sendObj = {};
    sendObj["id"] = data.enquiry_pk_id;
    sendObj["enquiry_status"] = "accepted";
    patchEnquiry(sendObj, dispatch);
  };

  useEffect(() => {
    if (!isEmpty(orders?.data) && orders?.data.length > 0) {
      let tempNewOrder = orders?.data.filter(
        (item) => item.status === "placed" || item.status === "inprocess",
      ); // Replace with your desired filter condition
      let tempAcceptedOrder = orders?.data.filter((item) => item.status === "accepted"); // Replace with your desired filter condition
      setNewOrder(tempNewOrder);
      setAcceptedOrder(tempAcceptedOrder);
    }
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(enquiry?.data?.enquiryDetails) && enquiry?.data?.enquiryDetails.length > 0) {
      let tempPendingEnquiries = enquiry?.data?.enquiryDetails.filter(
        (item) => item.enquiry_status === "pending",
      );
      setPendingEnquiries(tempPendingEnquiries);
    }
  }, [enquiry]);

  const OrderDetailsModal = () => {
    return (
      <CustomModalWrap
        className="modal-custom-class order-popup"
        hedaerContent={
          <>
            <h4>{"Order"}</h4>
            <p
              onClick={() => {
                orderViewToggle();
              }}
            >
              <CloseIcon />
            </p>
          </>
        }
        buttonClasses={"action-button  hidden"}
        buttonContant={"view"}
        isModalOpen={showOrderModal}
        showModal={orderViewToggle}
        closeModal={orderViewToggle}
      >
        <DashbordOrder
          id={currentOrderId}
          closeModal={orderViewToggle}
          isModalOpen={showOrderModal}
        />
      </CustomModalWrap>
    );
  };

  const handleCalculateDeliveryCharge = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating delivery charge for value:", value);
    debouncedUpdatePrice(value, "deliveryChargeFinal");
  };

  const handleCalculateHandlingCharges = (e) => {
    const value = e.target.value;
    // Add your calculation logic here
    console.log("Calculating handling charges for value:", value);
    debouncedUpdatePrice(value, "handlingChargesFinal");
  };

  const debouncedUpdatePrice = useCallback(
    debounce((value, fieldName) => {
      let obj = {};
      obj["price"] = value;
      postGetGSTPrice(obj, dispatch).then((res) => {
        if (res && res.data) {
          // Handle the response data as needed
          console.log("Calculated Price Data:", res.data);
          if (res.data.success) {
            onSelectValue(res.data.data.gstAmount.toFixed(2), fieldName);
          }
        }
      });
    }, 1000), // Adjust delay as needed
    [],
  );

  useEffect(() => {
    if (!auth?.user?.onboarding) {
      let mSteps = [...STEPS];
      mSteps =
        auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER
          ? mSteps
          : mSteps.filter((el) => el.key !== TABS.FACTORY);

      if (mySubscription?.sellerInfo?.app_features === "leads") {
        mSteps = mSteps.filter((el) => el.key !== TABS.LOGISTICS);
        setSteps(mSteps);
      } else {
        setSteps(mSteps);
      }

      setTimeout(() => {
        setActiveTab(activeOnboardingTab);
      }, 500);
    }
  }, [auth, mySubscription, activeOnboardingTab]);

  if (auth.user.onboarding) {
    return (
      <Container fluid className="py-2">
        {DialogModal}
        {pageLoading && <PageSpinner />}
        <Row className="mx-0 p-0 mb-2">
          <h1 className="p-0 title text-uppercase">{"Dashboard"}</h1>
        </Row>

        {!pageLoading && !isEmpty(topMessage) && (
          <Row className="mx-0 p-0">
            <Alert variant="danger" className="mb-0">
              <ul className="m-0 p-0 list-unstyled">
                {topMessage.map((msg, index) => (
                  <li key={index} className="d-flex align-items-start">
                    <span className="me-2 text-danger">✔</span>
                    <span>{msg}</span>
                  </li>
                ))}
              </ul>
            </Alert>
          </Row>
        )}

        <div className="stats-row mb-2" style={{ padding: "1px" }}>
          <StatCard
            cardTitle={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? "Total Enquiries"
                : "Total Sales"
            }
            statNumber={`₹ ${Number(
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.currentMonth?.total_enquiries
                : statisticsData?.currentMonth?.order_amount_total,
            ).toLocaleString("en-IN")}`}
            statPecentage={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.enquiryPercent
                : statisticsData?.salesPercent
            }
            statIcon={TotalSale}
          />
          <StatCard
            cardTitle={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? "Repeated Enquiries"
                : "Repeated Orders"
            }
            statNumber={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.repeatedEnquiries?.currentMonthCount
                : statisticsData?.repeatedOrders?.currentMonthCount
            }
            statPecentage={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.repeatedEnquiries?.repeatedEnquiriesPercent
                : statisticsData?.repeatedOrders?.repeatedOrdersPercent
            }
            statIcon={RepeatOrders}
          />
          <StatCard
            cardTitle={
              mySubscription?.sellerInfo?.app_features === "leads" ? "New Enquiries" : "New Orders"
            }
            statNumber={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.newEnquiries?.newEnquiriesCount
                : statisticsData?.newOrders?.newOrdersCount
            }
            statPecentage={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.newEnquiries?.newEnquiriesPercent
                : statisticsData?.newOrders?.newOrdersPercent
            }
            statIcon={NewOrders}
          />
          <StatCard
            cardTitle={"Customers"}
            statNumber={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.newBuyers?.newBuyersCount
                : statisticsData?.newBuyers?.newBuyersCount
            }
            statPecentage={
              mySubscription?.sellerInfo?.app_features === "leads"
                ? enquiryStatsData?.newBuyers?.newBuyersPercent
                : statisticsData?.newBuyers?.newBuyersPercent
            }
            statIcon={Customers}
          />
        </div>
        {OrderDetailsModal()}
        {EnquiryDetailsModal()}
        {/* After Order placed by buyers */}
        {/* New Orders section */}
        {(() => {
          if (auth?.user?.app_features !== "leads") {
            if (isEmpty(newOrder) && newOrder.length < 1) {
              return (
                <Row className="section-row mb-4 no-records">
                  <h4 className="p-0">{"New Orders"}</h4>
                  <p>{"No new orders available at the moment."}</p>
                </Row>
              );
            } else {
              return (
                <Row className="section-row mb-4 no-records px-1">
                  {/* Clickable header */}
                  <Row
                    className="mx-0 mb-2"
                    style={{
                      cursor: "pointer",
                      borderBottom: "1px solid #ddd",
                      padding: "0.5rem 0",
                    }}
                    onClick={() => setIsOrderOpen(!isOrderOpen)}
                  >
                    <Col xs="auto" className="flex-grow-1">
                      <h4 className="m-0">New Orders</h4>
                    </Col>
                    <Col xs="auto">
                      <i
                        className={`bi ${isOrderOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                    </Col>
                  </Row>

                  {/* Collapsible content */}
                  <Collapse in={isOrderOpen}>
                    <div>
                      <Row className="mb-0">
                        <CustomTable
                          enableRowActions
                          data={newOrder}
                          enableTopToolbar={false}
                          enableBottomToolbar={true}
                          enablePagination={true}
                          enableFilters={false}
                          positionActionsColumn={"last"}
                          emptyTableMsg={`No new orders available at the moment.`}
                          columns={tableStructures.new_orders_seller}
                          initialState={{
                            columnPinning: {
                              right: ["mrt-row-actions"],
                            },
                          }}
                          renderTopToolbarCustomActions={({ table }) => (
                            <Row
                              style={{
                                display: "flex",
                                gap: "1rem",
                                p: "0.5rem",
                                flexWrap: "wrap",
                              }}
                            >
                              <h4>{"New Orders"}</h4>
                            </Row>
                          )}
                          renderRowActions={({ row, table }) => (
                            <div className="table-action-box">
                              <CustomButton
                                buttonClasses="action-button accept"
                                id={row.original.id}
                                onClick={() => {
                                  // Logic to view order details can be added here
                                  setCurrentOrderId(row.original.id);
                                  orderViewToggle();
                                }}
                              >
                                <span className="fw-bolder">
                                  <i className="bi bi-eye-fill icon-lg"></i>
                                </span>
                              </CustomButton>
                              &nbsp;
                              <CustomButton
                                buttonClasses="action-button accept"
                                id={row.original.id}
                                onClick={() => {
                                  acceptOrderStatus(row.original);
                                }}
                              >
                                {"Accept"}
                              </CustomButton>
                            </div>
                          )}
                        />
                      </Row>
                    </div>
                  </Collapse>
                </Row>
              );
            }
          }
        })()}

        {/* Pending Enquiries section */}
        {isEmpty(pendingEnquiries) && pendingEnquiries.length < 1 ? (
          <Row className="section-row mb-4 no-records">
            <h4 className="p-0">{"New Enquiries"}</h4>
            <p>{"No new enquiries available at the moment."}</p>
          </Row>
        ) : (
          <Row className="section-row mb-4 no-records px-1">
            {/* Clickable header */}
            <Row
              className="mx-0 mb-2"
              style={{
                cursor: "pointer",
                borderBottom: "1px solid #ddd",
                padding: "0.5rem 0",
              }}
              onClick={() => setIsOpen(!isOpen)}
            >
              <Col xs="auto" className="flex-grow-1">
                <h4 className="m-0">New Enquiries</h4>
              </Col>
              <Col xs="auto">
                <i
                  className={`bi ${isOpen ? "bi-dash-lg" : "bi-plus-lg"}`}
                  style={{ fontSize: "1.2rem" }}
                ></i>
              </Col>
            </Row>

            {/* Collapsible content */}
            <Collapse in={isOpen}>
              <div>
                <Row className="mb-0">
                  <CustomTable
                    enableRowActions
                    data={pendingEnquiries}
                    enableTopToolbar={false}
                    enableBottomToolbar={true}
                    enablePagination={true}
                    enableFilters={false}
                    positionActionsColumn={"last"}
                    emptyTableMsg={`No new enquiries available at the moment.`}
                    columns={tableStructures.pending_enquiries}
                    initialState={{
                      columnPinning: {
                        right: ["mrt-row-actions"],
                      },
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                        <h4>{"New Enquiries"}</h4>
                      </Row>
                    )}
                    renderRowActions={({ row, table }) => (
                      <div className="table-action-box">
                        <CustomButton
                          buttonClasses="action-button accept"
                          id={row.original.enquiry_pk_id}
                          onClick={() => {
                            // Logic to view enquiry details can be added here
                            setCurrentEnquiryPkId(row.original.enquiry_pk_id);
                            enquiryViewToggle();
                          }}
                        >
                          <span className="fw-bolder">
                            <i className="bi bi-eye-fill icon-lg"></i>
                          </span>
                        </CustomButton>
                        &nbsp;
                        <CustomButton
                          buttonClasses="action-button accept"
                          id={row.original.id}
                          onClick={() => {
                            acceptEnquiryStatus(row.original);
                          }}
                        >
                          {"Accept"}
                        </CustomButton>
                      </div>
                    )}
                  />
                </Row>
              </div>
            </Collapse>
          </Row>
        )}
      </Container>
    );
  } else {
    const activeIndex = steps.findIndex((step) => step.key === activeOnboardingTab);
    const progressPercentage = (activeIndex / steps.length) * 100;

    return (
      <Container fluid className="py-2 seller-onboarding">
        {DialogModal}

        <Row className="mx-0 p-0 mb-4">
          <h1 className="p-0 title text-uppercase">{"Complete your onboarding"}</h1>
        </Row>
        <Row className="mx-0 p-0 mb-4 onboarding modal-custom-class">
          <div className="onboarding-progress">
            {/* Progress line */}
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${progressPercentage}%` }} />
            </div>

            {/* Steps */}
            <div className="steps">
              {steps.map((step, index) => {
                const isCompleted = index < activeIndex;
                const isActive = index === activeIndex;

                return (
                  <div key={step.key} className="step">
                    <div
                      className={`step-dot ${isCompleted ? "completed" : isActive ? "active" : ""}`}
                    />
                    <span className="step-label">{step.label}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            id="uncontrolled-tab-example"
          >
            {visibleTabs.includes(TABS.ADDRESS) && (
              <Tab key={TABS.ADDRESS} eventKey={TABS.ADDRESS} title="Address">
                <Address />
                {(() => {
                  if (addresses?.data?.length > 0) {
                    if (isEmpty(billingAddress)) {
                      return (
                        <h4 className="py-4 px-3 title text-danger">Please add billing address.</h4>
                      );
                    } else if (isEmpty(deliveryAddress) && isEmpty(warehouseAddress)) {
                      return (
                        <h4 className="py-4 px-3 title text-danger">
                          Please add delivery / warehouse address.
                        </h4>
                      );
                    } else {
                      // return (
                      //   <h4 className="py-4 px-3 title ">{`Move to  ${activeOnboardingTab} tab.`}</h4>
                      // );
                    }
                  } else {
                    // return (
                    //   <h4 className="py-4 px-3 title ">{`Please fill the details then move to next tab`}</h4>
                    // );
                  }
                })()}
              </Tab>
            )}
            {visibleTabs.includes(TABS.BANKING) && (
              <Tab key={TABS.BANKING} eventKey={TABS.BANKING} title="Banking info">
                <BankingAndTaxation />
                {/* {!isEmpty(bankInfo?.data) ? (
                  <h4 className="py-4 px-3 title ">{`Move to  ${activeOnboardingTab} tab`}</h4>
                ) : (
                  <h4 className="py-4 px-3 title ">{`Please fill the details then move to next tab`}</h4>
                )} */}
              </Tab>
            )}
            {auth?.user?.roles_type?.role_type_name === stringConstants.ROLL_TYPE_MANUFACTURER &&
              visibleTabs.includes(TABS.FACTORY) && (
                <Tab key={TABS.FACTORY} eventKey={TABS.FACTORY} title="Factory info">
                  <FactoryInfo />
                  {/* {!isEmpty(bankInfo?.data) ? (
                    <h4 className="py-4 px-3 title ">{`Move to  ${activeOnboardingTab} tab`}</h4>
                  ) : (
                    <h4 className="py-4 px-3 title ">{`Please fill the details then move to next tab`}</h4>
                  )} */}
                </Tab>
              )}
            {mySubscription?.sellerInfo?.app_features !== "leads" &&
              visibleTabs.includes(TABS.LOGISTICS) && (
                <Tab key={TABS.LOGISTICS} eventKey={TABS.LOGISTICS} title="Logistic Partners">
                  <LogisticPartner fromOnboarding={true} setOnboardingLpList={setLpList} />
                </Tab>
              )}
            {visibleTabs.includes(TABS.FINAL) && (
              <Tab key={TABS.FINAL} eventKey={TABS.FINAL} title="Final">
                <Row className="m-0 w-full  form-row ">
                  <Row className="heading-div ">
                    <h5 className="text-uppercase">{"Final Step"}</h5>
                  </Row>
                  <Form className="modal-custom-class  px-0" onSubmit={completeOnboarding}>
                    <Row className="m-0 px-0">
                      {bhareeAdminBasicTable?.data?.deliveryTypes?.length > 0 && (
                        <Col xs={12} md={6}>
                          <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>
                              {"Select Delivery Types"}
                              <span className="redStreSpan">{"*"}</span>
                            </Form.Label>

                            <CustomSelectDropdown
                              style={{
                                multiselectContainer: {
                                  backgroundColor: "#f8f8f8",
                                },
                                chips: {
                                  margin: 0,
                                },
                                option: {
                                  background: "#fbb040",
                                  color: "#FFFFFF",
                                  borderBottom: "1px solid #FFFFFF",
                                },
                              }}
                              options={bhareeAdminBasicTable?.data?.deliveryTypes}
                              onSelect={(e) => onSelectValue(e, "delivery_types")}
                              onRemove={(e) => onSelectValue(e, "delivery_types")}
                              selectedValues={
                                Object.prototype.hasOwnProperty.call(
                                  deliveryFormObj,
                                  "delivery_types",
                                )
                                  ? deliveryFormObj["delivery_types"]
                                  : []
                              }
                              displayValue={"name"}
                              disable
                              singleSelect
                            />
                          </Form.Group>
                        </Col>
                      )}
                      {bhareeAdminBasicTable?.data?.paymentTypes?.length > 0 && (
                        <Col xs={12} md={6}>
                          <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>
                              {"Select Payment Types"}
                              <span className="redStreSpan">{"*"}</span>
                            </Form.Label>

                            <CustomSelectDropdown
                              disablePreSelectedValues
                              style={{
                                multiselectContainer: {
                                  backgroundColor: "#f8f8f8",
                                },
                                chips: {
                                  background: "#fbb040",
                                  margin: 0,
                                },
                                option: {
                                  background: "#fbb040",
                                  color: "#FFFFFF",
                                  borderBottom: "1px solid #FFFFFF",
                                },
                              }}
                              options={bhareeAdminBasicTable?.data?.paymentTypes}
                              onSelect={(e) => onSelectValue(e, "payment_types")}
                              onRemove={(e) => onSelectValue(e, "payment_types")}
                              selectedValues={FilterObjectsByKeyValue(
                                bhareeAdminBasicTable?.data?.paymentTypes,
                                "name",
                                "Pay Now",
                              )}
                              displayValue={"name"}
                            />
                          </Form.Group>
                        </Col>
                      )}

                      <Col xs={12} md={6} lg={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Delivery Charges (Per Case) "}
                            <span className="redStreSpan">{"*"}</span>
                            {deliveryFormObj?.deliveryChargeFinal && (
                              <span className="positiveMsg pointer">
                                {` Final (with 18% GST): ₹ ${deliveryFormObj?.deliveryChargeFinal}`}
                              </span>
                            )}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={deliveryFormObj?.deliveryCharge}
                            onChange={(e) => {
                              onSelectValue(e.target.value, "deliveryCharge");
                              handleCalculateDeliveryCharge(e);
                            }}
                          />
                          <p className="m-0 p-0 text-danger small">
                            * Delivery charges should be entered without GST
                          </p>
                        </Form.Group>
                      </Col>

                      <Col xs={12} md={6} lg={6}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>
                            {"Handling Charges (Per Case) "}
                            <span className="redStreSpan">{"*"}</span>
                            {deliveryFormObj?.handlingChargesFinal && (
                              <span className="positiveMsg pointer">
                                {` Final (with 18% GST): ₹ ${deliveryFormObj?.handlingChargesFinal}`}
                              </span>
                            )}
                          </Form.Label>
                          <Form.Control
                            type="text"
                            required
                            value={deliveryFormObj?.handling_charges}
                            onChange={(e) => {
                              onSelectValue(e.target.value, "handling_charges");
                              handleCalculateHandlingCharges(e);
                            }}
                          />
                          <p className="m-0 p-0 text-danger small">
                            * Handling charges should be entered without GST
                          </p>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="m-0 px-0">
                      <Col xs={12} md={6}>
                        <Form.Group controlId="formFile" className="mb-3">
                          <Form.Label>
                            Upload Signature (PNG/JPG ≤ 2MB)
                            <span className="redStreSpan">{"*"}</span>
                          </Form.Label>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            className="custom-file-input"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="action-buttons">
                      {addresses?.data?.length > 0 && !isEmpty(bankInfo?.data) ? (
                        <>
                          {!isEmpty(errorMessage) && (
                            <h4 className="py-2 px-3 m-0 title text-danger">{errorMessage}</h4>
                          )}
                          {isEmpty(errorMessage) && (
                            <h4 className="px-3 m-0 title ">{`Please check the details and complete the  ${activeOnboardingTab}  step.`}</h4>
                          )}
                          <CustomButton
                            variant="primary"
                            buttonClasses={
                              !requestCall?.loading ? "submit-btn" : "submit-btn-loading"
                            }
                            type="submit"
                            // onClick={() => }
                            loading={requestCall?.loading}
                          >
                            {"Submit"}
                          </CustomButton>
                        </>
                      ) : (
                        <>
                          <h4 className="py-4 px-3 m-0 title ">{`Please complete the  ${activeOnboardingTab}  step`}</h4>
                        </>
                      )}
                    </div>
                  </Form>
                </Row>
              </Tab>
            )}
          </Tabs>
        </Row>
      </Container>
    );
  }
};

export default Dashbord;
